import { render, staticRenderFns } from "./GameGuess.vue?vue&type=template&id=282f15b0&"
import script from "./GameGuess.vue?vue&type=script&lang=js&"
export * from "./GameGuess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports